import React from 'react'
import { NavLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { GeneralConsumer } from '../../context/GeneralContext'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../routes'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined'
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined'
import ChevronLeftOutlinedIcon from '@material-ui/icons/ChevronLeftOutlined'
import CenterFocusStrongOutlinedIcon from '@material-ui/icons/CenterFocusStrongOutlined'
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined'
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined'
import Configuration from '../../Services/Api/Configuration'
import { AuthConsumer } from '../../context/AuthContext'
import { LanguageConsumer } from '../../context/LanguageContext'


const MainNavigation = () => {
  const classes = useStyles()
  const { permissions } = Configuration
  const navMenu = [
    {
      key: 1,
      label: <FormattedMessage id='MainNavigation.link.home'/>,
      icon: <HomeOutlinedIcon/>,
      link: NamedRoutes.home
    },
    {
      key: 5,
      label: <FormattedMessage id='MainNavigation.link.invoices'/>,
      icon: <DescriptionOutlinedIcon/>,
      link: NamedRoutes.invoices,
      permission: permissions.invoice.view
    },
    {
      key: 25,
      label: <FormattedMessage id='MainNavigation.link.lateSubmission'/>,
      icon: <ScheduleOutlinedIcon/>,
      link: NamedRoutes.lateSubmission,
      // permission: permissions.invoice.view
    },
    {
      key: 10,
      label: <FormattedMessage id='MainNavigation.link.invoicePackages'/>,
      icon: <ArchiveOutlinedIcon/>,
      link: NamedRoutes.invoicePackages,
      permission: permissions.invoicePackages
    },
    {
      key: 15,
      label: <FormattedMessage id='MainNavigation.link.codes'/>,
      icon: <CenterFocusStrongOutlinedIcon/>,
      link: NamedRoutes.codes,
      permission: permissions.code
    },
    {
      key: 20,
      label: <FormattedMessage id='MainNavigation.link.Notifications'/>,
      icon: <NotificationsOutlinedIcon/>,
      link: NamedRoutes.notifications,
      permission: permissions.notification
    }

  ]
  return (
    <GeneralConsumer>{({ toggleMobileMenuDrawer }) => (
      !!navMenu?.length &&
      <div className={classes.mainNavigationWrapper}>
        <LanguageConsumer>
          {({ locale }) => (
            <AuthConsumer>
              {({ userPermissions }) => (
                <nav className={classes.mainNavigation}>
                  <ul>
                    {navMenu.map((item, index) => (
                      (!item.permission || !!userPermissions?.includes(item.permission || '')) &&
                      <li key={index}>
                        <NavLink
                          exact
                          activeClassName="active"
                          to={item.link}
                          isActive={(match, location) => {
                            let pathStrings = location.pathname.split('/')
                            if (match) {
                              return true
                            } else {
                              return pathStrings[1] === item.link.replace('/', '')
                            }
                          }}
                          onClick={() => toggleMobileMenuDrawer(false)}
                        >
                        <span className={classes.menuTextWrapper}>
                        {!!item?.icon && <span className={classes.iconWrapper}>{item.icon}</span>}
                          {item?.label || ''}
                        </span>
                          <span className={classes.navigatorWrapper}>{locale === 'ar' ? <ChevronLeftOutlinedIcon/> :
                            <ChevronRightOutlinedIcon/>}</span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </nav>
              )}
            </AuthConsumer>
          )}
        </LanguageConsumer>
      </div>
    )}
    </GeneralConsumer>
  )
}

export default MainNavigation
